import type { Branded } from "@@/utilities/branded";
import { genericId } from "@@/utilities/generic-id";

type BookableSessionSeriesId = Branded<string, "BookableSeriesId">;
const bookableSessionSeriesIdPrefix = "bookable_series__";
const {
    factory: bookableSessionSeriesIdFactory,
    assert: isBookableSessionSeriesId,
    zodSchema: bookableSessionSeriesIdZodSchema,
} = genericId<BookableSessionSeriesId>(bookableSessionSeriesIdPrefix, {
    regexMatch: /(^bookable_series_.*$)/,
});

export {
    bookableSessionSeriesIdPrefix as bookableSeriesIdPrefix,
    bookableSessionSeriesIdFactory,
    bookableSessionSeriesIdZodSchema,
    isBookableSessionSeriesId,
};
export type { BookableSessionSeriesId };
